export default "__VITE_ASSET__DkKR8HwH__"